import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const joinEvents = (events, t) =>
  events
    .map((event) => t(`emailAutomations.builder.exit.events.${event}`))
    .join(", ")
    .replace(/, ([^,]*)$/, ` ${t("emailAutomations.builder.filter.and")} $1`);

// What stops the automation for a member, and when a member can go through it again
const ExitCard = ({ automation, selected, href }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) => t(`emailAutomations.builder.exit.${key}`, params);
  const events = automation.exitRules.map((rule) => rule.event);
  return (
    <a
      className={`ab-card ab-card--exit${selected ? " ab-card--selected" : ""}`}
      href={href}
    >
      <span className="ab-card__label">{tr("label")}</span>
      <span className="ab-card__body">
        {events.length > 0
          ? tr("text", { events: joinEvents(events, t) })
          : tr("none")}
        <br />
        {tr("marketing")}
      </span>
      <small>{tr(`reentry.${automation.reentry}`)}</small>
    </a>
  );
};

ExitCard.propTypes = {
  automation: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  href: PropTypes.string.isRequired,
};

export default ExitCard;
